import { render } from "./Blocks.vue?vue&type=template&id=8f8b9d22"
import script from "./Blocks.vue?vue&type=script&lang=js"
export * from "./Blocks.vue?vue&type=script&lang=js"

import "./Blocks.vue?vue&type=style&index=0&id=8f8b9d22&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Blocks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f8b9d22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f8b9d22', __exports__)) {
    api.reload('8f8b9d22', __exports__)
  }
  
  module.hot.accept("./Blocks.vue?vue&type=template&id=8f8b9d22", () => {
    api.rerender('8f8b9d22', render)
  })

}


export default __exports__